<template>
    <section>
      <div class="table-responsive">
        <table id="tableName" class="mdl-data-table mdl-js-data-table mdl-shadow--2dp">
	      <thead>
	        <tr>
	          <th class="mdl-data-table__cell--non-numeric">Player Name</th>
            <th v-if="showActions">Action</th>
            <th @click="setSortCat('team','team')">KBO Team </th>
            <th @click="setSortCat('ip','newIp')">IPs</th>
            <th @click="setSortCat('wins','newWins')">Wins</th>
            <th @click="setSortCat('ks','newKs')">Ks</th>
            <th @click="setSortCat('earnedRuns','newEarnedRuns')">ER</th>
            <th @click="setSortCat('saves','newSaves')">Saves</th>
            <th @click="setSortCat('whip','newWhip')">WHIP</th>
            <th @click="setSortCat('era','newEra')">ERA</th>
	        </tr>
	      </thead>
	      <tbody v-if="weekKey=='season'">
	          <tr v-for="b of sortSeasonPitchers" v-if="b.owners[leagueKey]==ownershipView" :key="b['.key']">
	            <td style="text-align: left"><a target="_blank" rel="noopener noreferrer" :href="'https://mykbostats.com'+b.link">{{ b.name }}</a></td>
              <td v-if="showActions"><button type="button" id="show-modal2" class="mdl-button-action mdl-js-button mdl-js-ripple-effect" :style="actionStyle" @click="show(b)">{{actionName}}</button> </td>
	            <td>{{ b.team }}</td>
	            <td>{{ b.ip }}</td>
	            <td>{{ b.wins }}</td>
	            <td>{{ b.ks }}</td>
	            <td>{{ b.earnedRuns }}</td>
	            <td>{{ b.saves }}</td>
	            <td>{{ b.whip }}</td>
	            <td>{{ b.era }}</td>
	          </tr>
	      </tbody>
        <tbody v-else-if="weekKey=='season2020'">
            <tr v-for="b of sort2020Pitchers" v-if="b.owners[leagueKey]==ownershipView && b.pastSeasons && b.pastSeasons['season2020']" :key="b['.key']">
              <td style="text-align: left"><a target="_blank" rel="noopener noreferrer" :href="'https://mykbostats.com'+b.link">{{ b.name }}</a></td>
              <td v-if="showActions"><button type="button" id="show-modal2" class="mdl-button-action mdl-js-button mdl-js-ripple-effect" :style="actionStyle" @click="show(b)">{{actionName}}</button> </td>
              <td>{{ b.team }}</td>
              <td>{{ (b.pastSeasons && b.pastSeasons["season2020"]) ? b.pastSeasons["season2020"].ip  : 0}}</td>
              <td>{{ (b.pastSeasons && b.pastSeasons["season2020"]) ? b.pastSeasons["season2020"].wins  : 0}}</td>
              <td>{{ (b.pastSeasons && b.pastSeasons["season2020"]) ? b.pastSeasons["season2020"].ks  : 0}}</td>
              <td>{{ (b.pastSeasons && b.pastSeasons["season2020"]) ? b.pastSeasons["season2020"].earnedRuns  : 0}}</
              <td>{{ (b.pastSeasons && b.pastSeasons["season2020"]) ? b.pastSeasons["season2020"].saves  : 0}}</td>
              <td>{{ (b.pastSeasons && b.pastSeasons["season2020"]) ? b.pastSeasons["season2020"].whip  : 0}}</td>
              <td>{{ (b.pastSeasons && b.pastSeasons["season2020"]) ? b.pastSeasons["season2020"].era  : 0}}</td>
            </tr>
        </tbody>
        <tbody v-else>
            <tr v-for="b of sortWeekPitchers" v-if="b.owners[leagueKey]==ownershipView && b.season && b.season[weekKey]" :key="b['.key']">
              <td style="text-align: left"><a target="_blank" rel="noopener noreferrer" :href="'https://mykbostats.com'+b.link">{{ b.name }}</a></td>
              <td v-if="showActions"><button type="button" id="show-modal2" class="mdl-button-action mdl-js-button mdl-js-ripple-effect" :style="actionStyle" @click="show(b)">{{actionName}}</button> </td>
              <td>{{ b.team }}</td>
              <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newIp.toFixed(3) : 0 }}</td>
              <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newWins : 0 }}</td>
              <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newKs : 0 }}</td>
              <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newEarnedRuns : 0 }}</td>
              <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newSaves : 0 }}</td>
              <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newWhip : 0 }}</td>
              <td>{{ (b.season && b.season[weekKey]) ? b.season[weekKey].newEra : 0 }}</td>
            </tr>
        </tbody>
	    </table>
    </div>
  </section>
</template>

<script>
 export default {
  props: {
   tableName: "",
   weekKey: { 
    type: String, // not 'string'
    required: false,
    default: "season"
   },
   teamKey: { 
    type: String, // not 'string'
    required: false,
    default: null
   },
   leagueKey: { 
    type: String, // not 'string'
    required: true,
    default: ""
   },
   leagueStatus: { 
    type: String, // not 'string'
    required: false,
    default: "locked"
   },
   ownershipView: { 
    type: String, // not 'string'
    required: false,
    default: "FreeAgent"
   },
   userUID: {
    type: String, // not 'string'
    required: false,
    default: "useruid"
   },
   pitchers: { },
   
  },
  computed: {
    sortSeasonPitchers() {
      return this.pitchers.slice().sort((a,b) => this.sortByCat(a,b)
      )
    }, 
    sortWeekPitchers() {
      return this.pitchers.slice().sort((a,b) => this.sortByWeekCat(a,b)
      )
    },  
    sort2020Pitchers() {
      return this.pitchers.slice().sort((a,b) => this.sortBy2020SeasonCat(a,b)
      )
    }, 
    showActions() {
      return this.teamKey!=null && (this.leagueStatus!='pre')
    },
    actionName() {
      if (this.leagueStatus=='unlocked'){
        return "Add"
      } else if (this.leagueStatus=='draft'){
        return "Draft"
      } else if (this.leagueStatus=='locked') {
        return "Claim"
      }
      return ""
    },
    actionStyle() {
      if (this.leagueStatus=='unlocked' || this.leagueStatus=='draft'){
        return this.addStyle
      } 
      return this.claimStyle 
    },
  },
  data() {
    return {
      sortWeekCat: "newIp",
      sortCat: "ip",
      addStyle: {
        "background-color" : "#41ab0b"
      },
      claimStyle: {
        "background-color" : "#e6d509"
      },
    }
  },
  methods : {
    sortByCat(a,b){
      return b[this.sortCat] - a[this.sortCat]
    },
    sortByWeekCat(a,b){
      let tmpb = (b.season && b.season[this.weekKey]) ? b.season[this.weekKey][this.sortWeekCat] : 0
      let tmpa = (a.season && a.season[this.weekKey]) ? a.season[this.weekKey][this.sortWeekCat] : 0
      return tmpb - tmpa
    },
    sortBy2020SeasonCat(a,b){
      let tmpb = (b.pastSeasons && b.pastSeasons["season2020"]) ? b.pastSeasons["season2020"][this.sortCat] : 0
      let tmpa = (a.pastSeasons && a.pastSeasons["season2020"]) ? a.pastSeasons["season2020"][this.sortCat] : 0
      return tmpb - tmpa
    },
    setSortCat(seasonC, weekC){
      this.sortCat = seasonC
      this.sortWeekCat = weekC
    } ,
    show (player) {
      this.$modal.show('addplayermodal',{
        newPlayer: player, 
        leagueKey: this.leagueKey, 
        teamKey: this.teamKey,
        action: this.actionName,
        userUID: this.userUID,
      });
    }, 
  } 
}
</script>


// WEBPACK FOOTER //
// src/components/PitcherTable.vue